module.exports = __webpack_public_path__ + "img/number4.4d0faa74.svg";